import React from 'react';

export default class VirtualBody extends React.Component {
	render() {
		return (
			<div className="b3-virtual-body">
				{this.props.children}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./app/b3/misc/VirtualBody.js